import { LoadingCard } from "./LoadingListCards";
import SecondaryHeading from "./SecondaryHeading";

export default function ModuleLimitDetail({
  isLoading,
  title,
  description,
  progress,
  barHeight = '6px',
  barStyle = {},
}) {
  return (
    <>
      <div className="w-full">
        <SecondaryHeading>{title}</SecondaryHeading>
        {isLoading ? (
          <LoadingCard className="h-2 mt-4" />
        ) : (
          description && <p className="body-text m-0 !mt-1-5">{description}</p>
        )}
        {isLoading ? (
          <LoadingCard className="h-2 mt-3" />
        ) : (
          <div className="site-bar" style={{ ...barStyle, height: barHeight }}>
            <div style={{ width: `${progress >= 100 ? 100 : progress%100}%`, height: barHeight}}></div>
          </div>
        )}
      </div>
    </>
  );
}
